export default "__VITE_ASSET__D0atkKqH__"